import { handle } from 'redux-pack';
import { Action } from "../../../types/actions";
import { ADD_ADMIN, GET_ADMINS, SET_WORKING_PERMISSIONS, UPDATE_PERMISSIONS, REMOVE_ADMIN } from '../../actions/admin/bl-admin';
import { BLAdmin } from '../../../types/working-model';

export interface ChannelAdminState {
    admins: BLAdmin[]
    workingPermissions: string[] | null
}

const initialState: ChannelAdminState = {
    admins: [],
    workingPermissions: null
};

export default function BLAdminReducer(state: ChannelAdminState = initialState, action: Action): ChannelAdminState {
    switch (action.type) {
        case GET_ADMINS: {
            return handle(state, action, {
                success: state => ({ ...state, admins: action.payload })
            });
        }
        case SET_WORKING_PERMISSIONS: {
            return ({ ...state, workingPermissions: action.payload});
        }
        case UPDATE_PERMISSIONS: {
            return handle(state, action, {
                success: state => {
                    const updatedAdmins = [...state.admins];
                    for (const admin of updatedAdmins) {
						if (admin.id === action.payload.id) {
                            admin.channels = action.payload.channels;
                            break;
                        }
                    }
                    return {
                        ...state,
                        admins: updatedAdmins
                    };
                },
                failure: state => {
                    return state;
                }
            });                
        }
		case ADD_ADMIN: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						admins: [...state.admins, action.payload]
					};
				}
			});
		}
		case REMOVE_ADMIN: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						admins: state.admins.filter((admin: BLAdmin) => admin.id !== action.payload.id)
					};
				},
				failure: state => {
					return state;
				}
			});
		}
        default: return state;
    }
}